import { ActivitiesTab } from "@/pages/ContactsPage/Tabs";

export const ActivitiesMobile = () => {
  return <ActivitiesTab />;
};
